import * as React from 'react';

import { NonEmptyArray, EDecorationType } from '../../../../../JsonQuery';
import { ERepair } from '../../../types/jsonQuery';
import { CheckboxButtonGroupUnselectable } from '../../CheckboxButtonGroupUnselectable';
import { Filter } from '../common/Filter';
import { InlineFilter } from '../common/InlineFilter';
import { InlineFilterGroup } from '../common/InlineFilterGroup';
import { FilterSection } from '../common/InlineFilterSection';

interface IOption<T> {
  label: string;
  value: T | null;
}

const REPAIRS: IOption<ERepair>[] = [
  { label: 'Неважно', value: null },
  { label: 'Без ремонта', value: ERepair.Without },
  { label: 'Косметический', value: ERepair.Cosmetic },
  { label: 'Евроремонт', value: ERepair.Euro },
  { label: 'Дизайнерский', value: ERepair.Design },
];

const DECORATIONS: IOption<EDecorationType>[] = [
  { label: 'Неважно', value: null },
  { label: 'Чистовая с мебелью', value: EDecorationType.FineWithFurniture },
  { label: 'Чистовая', value: EDecorationType.Fine },
  { label: 'Предчистовая', value: EDecorationType.PreFine },
  { label: 'Без отделки', value: EDecorationType.Without },
];

interface IRenovationProps {
  repairValue: NonEmptyArray<ERepair> | null;
  decorationValue: NonEmptyArray<EDecorationType> | null;
  onRepairChange(value: NonEmptyArray<ERepair> | null): void;
  onDecorationChange(value: NonEmptyArray<EDecorationType> | null): void;
}

export const Renovation: React.FC<IRenovationProps> = ({
  repairValue,
  decorationValue,
  onRepairChange,
  onDecorationChange,
}) => {
  return (
    <Filter id="advancedFilter_renovation" label="Ремонт и отделка">
      <InlineFilterGroup>
        <FilterSection title="На вторичке">
          <InlineFilter>
            <CheckboxButtonGroupUnselectable options={REPAIRS} value={repairValue} onChange={onRepairChange} />
          </InlineFilter>
        </FilterSection>
      </InlineFilterGroup>
      <InlineFilterGroup>
        <FilterSection title="В новостройках">
          <InlineFilter>
            <CheckboxButtonGroupUnselectable
              options={DECORATIONS}
              value={decorationValue}
              onChange={onDecorationChange}
            />
          </InlineFilter>
        </FilterSection>
      </InlineFilterGroup>
    </Filter>
  );
};
